import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy-dark text-cream py-12 px-6" data-id="element-70">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-71">
        <div className="mb-8" data-id="element-72">
          <h3 className="font-heading text-2xl text-gold mb-4" data-id="element-73">
            RB Protection
          </h3>
          <p className="text-cream/80 flex items-center justify-center gap-2" data-id="element-74">
            <PhoneIcon className="w-4 h-4" data-id="element-75" />
            Soporte / Contacto: WhatsApp +1 786 397 5041
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-cream/60 mb-8" data-id="element-76">
          <Link to="/privacy" className="hover:text-gold transition-colors" data-id="element-77">
            Política de Privacidad
          </Link>
          <span className="hidden sm:inline" data-id="element-78">|</span>
          <Link to="/terms" className="hover:text-gold transition-colors" data-id="element-79">
            Términos del Servicio
          </Link>
        </div>

        <p className="text-xs text-cream/40" data-id="element-80">
          &copy; {new Date().getFullYear()} RB Protection. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}